import { ref } from "vue";

export const activeDropdownId = ref<string | null>(null);
export const openDropdownHierarchy = ref<string[]>([]); // 💡 tracks nesting chain
